module.exports = __webpack_public_path__ + "static/media/footerLogo.33cec651.svg";